import { render } from "./RespondingToPromotionComponent.vue?vue&type=template&id=7c435354&ts=true"
import script from "./RespondingToPromotionComponent.vue?vue&type=script&lang=ts"
export * from "./RespondingToPromotionComponent.vue?vue&type=script&lang=ts"

import "./RespondingToPromotionComponent.vue?vue&type=style&index=0&id=7c435354&lang=css"

import exportComponent from "D:\\a\\1\\s\\Website\\wwwroot\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__